import debug from 'bows/dist/bows.min.js';


const log = debug("inpage");


class InPage {

	constructor(node) {
		this.node = node;
		this.inpage = node.closest('.inpage');
		this.list = node.nextElementSibling;
		this.links = this.list.querySelectorAll('a');
		this.ids = document.querySelectorAll('[id]');
		this.trigger_text = this.inpage.querySelector('.inpage__trigger__text');
		this.hrefs = [];

		this.links.forEach(link => {
			this.hrefs.push(link.getAttribute('href'));
			link.addEventListener('click', (e) => {

				this.toggle()
				this.anchorLinkHandler(e, link, this.inpage)
			})

			link.addEventListener('focusout', () => {
				this.checkFocus()
			});
		})

		this.node.addEventListener('click', (e) => {
			this.toggle()
		})

		this.config = {
			threshold: [0.2]
		}

		this.observer = new IntersectionObserver(entries => {

			entries.forEach(entry => {
				let target_id = entry.target.id;
				if (this.hrefs.includes(`#${target_id}`)) {
					let inpage_link = this.inpage.querySelector(`[href="#${target_id}"]`);
					if (entry.isIntersecting && entry.intersectionRatio > 0.2) {
						let dropdown_text = inpage_link.innerText;
						this.trigger_text.innerText = dropdown_text;
						inpage_link.classList.add('inpage__current-section')

					} else {
						inpage_link.classList.remove('inpage__current-section')
					}
				}
			})
		}, this.config);

		this.ids.forEach(id => {
			this.observer.observe(id);
		})
	}

	anchorLinkHandler(e, link, inpage) {
		e.preventDefault();

		const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
		const inpageHeight = inpage.offsetHeight;
		const targetID = link.getAttribute("href");
		const split = targetID.split('#');

		// If only a hash return
		if (split[1] === '') return;
		const targetAnchor = document.querySelector(targetID);

		// If the ID does not exist return
		if (!targetAnchor) return;

		const originalTop = distanceToTop(targetAnchor) - inpageHeight;

		window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });

		const checkIfDone = setInterval(function () {
			const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
			if (distanceToTop(targetAnchor) === 0 || atBottom) {
				targetAnchor.tabIndex = "-1";
				targetAnchor.focus();

				window.history.pushState("", "", targetID);
				clearInterval(checkIfDone);
			}
			targetAnchor.addEventListener("blur", function () {
				targetAnchor.removeAttribute('tabIndex');
			});
		}, 100);
	}

	toggle() {
		this.node.classList.toggle('inpage__trigger--active')
	}

	checkFocus() {
		setTimeout(() => {
			let focused = this.list.querySelector(':focus');
			if (focused === null) {
				this.node.classList.remove('inpage__trigger--active');
			}
		}, 100);
	}

}

InPage.instances = Array.from(document.querySelectorAll('.inpage__trigger')).map(n => new InPage(n));

export default InPage;
